module.exports = __webpack_public_path__ + "static/img/icon_SUCCESS.9dac1be9.png";